<template>
  <div>
    <ProductTile
      v-for="(product, index) in products"
      :key="index"
      :asin="product.ASIN"
      :item-attributes="product.ItemAttributes"
      :item-offers="product.Offers"
      :title="product.ItemAttributes.Title"
      :description="product.EditorialReviews"
      :short-link="product.DetailPageURL"
      :img-link="product.MediumImage"
    />
  </div>
</template>

<script>
import { getAllProductsById } from '@/api'
import ProductTile from '@/components/ProductTile'

export default {
  name: 'SingleProduct',
  components: {
    ProductTile
  },
  props: {
    asin: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      products: []
    }
  },
  async created() {
    await this.getProducts()
  },
  methods: {
    async getProducts() {
      this.products = await getAllProductsById(this.asin).then(
        res => res.data.products
      )
    }
  }
}
</script>
